import { FormCategory, FormInputs } from './../types'

export const testFormId: string = '00DPw000000Dn7l'

export const testForm: { [key: string]: FormCategory } = {
  services: {
    type: "select",
    id: "00N7Q00000GG2hk",
    name: "00N7Q00000GG2hk",
    title: "Szolgáltatás megnevezése",
    label: "Szolgáltatás megnevezése",
    categoryName: "services",
    parentCategory: null,
    options: [
      { value: "Televíziós adások", title: "Televíziós adások", service: [], parent: null },
      { value: "RTL.hu weboldal", title: "RTL.hu weboldal", service: [], parent: null },
      { value: "RTL+ streaming", title: "RTL+ streaming", service: [], parent: null }
    ]
  },
  mainCategory: {
    type: "select",
    id: "00N7Q00000GG2ix",
    name: "00N7Q00000GG2ix",
    title: "Főkategória",
    label: "Kategória kiválasztása",
    categoryName: "mainCategory",
    parentCategory: null,
    options: [
      {
        value: "Hírműsorok",
        title: "Hírműsorok",
        service: ["tv"],
        parent: null
      },
      {
        value: "Időjárás jelentés",
        title: "Időjárás jelentés",
        service: ["tv"],
        parent: null
      },
      {
        value: "Casting",
        title: "Casting",
        service: ["tv"],
        parent: null
      },
      {
        value: "További műsorok",
        title: "További műsorok",
        service: ["tv"],
        parent: null
      },
      {
        value: "Szavazás/Nyereményjáték",
        title: "Szavazás/Nyereményjáték",
        service: ["hu"],
        parent: null
      },
      {
        value: "Híradó",
        title: "Híradó",
        service: ["hu"],
        parent: null
      },
      {
        value: "Casting",
        title: "Casting",
        service: ["hu"],
        parent: null
      },
      {
        value: "RTL+ Light",
        title: "RTL+ Light",
        service: ["plus"],
        parent: null
      },
      {
        value: "RTL+ Active (csak szolgáltatótól!)",
        title: "RTL+ Active (csak szolgáltatótól!)",
        service: ["plus"],
        parent: null
      },
      {
        value: "RTL+ Premium (One szolgáltatótól)",
        title: "RTL+ Premium (One szolgáltatótól)",
        service: ["plus"],
        parent: null
      },
      {
        value: "RTL+ Premium",
        title: "RTL+ Premium",
        service: ["plus"],
        parent: null
      }
    ]
  },
  subCategory: {
    type: "select",
    id: "00N7Q00000GG2iy",
    name: "00N7Q00000GG2iy",
    title: "Alkategória",
    label: "Alkategória kiválasztása",
    categoryName: "subCategory",
    parentCategory: "mainCategory",
    options: [
      {
        value: "Híresemény bejelentés, észrevétel",
        title: "Híresemény bejelentés, észrevétel",
        service: ["tv"],
        parent: "Hírműsorok"
      },
      {
        value: "Szerepléssel kapcsolatos bejelentés",
        title: "Szerepléssel kapcsolatos bejelentés",
        service: ["tv"],
        parent: "Hírműsorok"
      },
      {
        value: "Adáshibával kapcsolatos bejelentés",
        title: "Adáshibával kapcsolatos bejelentés",
        service: ["tv"],
        parent: "Hírműsorok"
      },
      {
        value: "Általános bejelentés, fotó beküldése",
        title: "Általános bejelentés, fotó beküldése",
        service: ["tv"],
        parent: "Időjárás jelentés"
      },
      {
        value: "Adáshibával kapcsolatos bejelentés",
        title: "Adáshibával kapcsolatos bejelentés",
        service: ["tv"],
        parent: "Időjárás jelentés"
      },
      {
        value: "Statisztának/szereplőnek/nézőnek való jelentkezés",
        title: "Statisztának/szereplőnek/nézőnek való jelentkezés",
        service: ["tv"],
        parent: "Casting"
      },
      {
        value: "Castinggal kapcsolatos általános érdeklődés",
        title: "Castinggal kapcsolatos általános érdeklődés",
        service: ["tv"],
        parent: "Casting"
      },
      {
        value: "Filmek, sorozatok",
        title: "Filmek, sorozatok",
        service: ["tv"],
        parent: "További műsorok"
      },
      {
        value: "Showműsorok",
        title: "Showműsorok",
        service: ["tv"],
        parent: "További műsorok"
      },
      {
        value: "UEFA",
        title: "UEFA",
        service: ["tv"],
        parent: "További műsorok"
      },
      {
        value: "Szavazás hibabejelentés",
        title: "Szavazás hibabejelentés",
        service: ["hu"],
        parent: "Szavazás/Nyereményjáték"
      },
      {
        value: "Általános információ/észrevétel",
        title: "Általános információ/észrevétel",
        service: ["hu"],
        parent: "Szavazás/Nyereményjáték"
      },
      {
        value: "Élő adással kapcsolatos bejelentés",
        title: "Élő adással kapcsolatos bejelentés",
        service: ["hu"],
        parent: "Híradó"
      },
      {
        value: "Általános információ/észrevétel",
        title: "Általános információ/észrevétel",
        service: ["hu"],
        parent: "Híradó"
      },
      {
        value: "Statisztának/szereplőnek/nézőnek való jelentkezés",
        title: "Statisztának/szereplőnek/nézőnek való jelentkezés",
        service: ["hu"],
        parent: "Casting"
      },
      {
        value: "Castinggal kapcsolatos általános érdeklődés",
        title: "Castinggal kapcsolatos általános érdeklődés",
        service: ["hu"],
        parent: "Casting"
      },
      {
        value: "Kupon kóddal kapcsolatos kérdések",
        title: "Kupon kóddal kapcsolatos kérdések",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Technikai segítségnyújtás",
        title: "Technikai segítségnyújtás",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Eszközök és beállítások",
        title: "Eszközök és beállítások",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Belépés az RTL+-ra",
        title: "Belépés az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Regisztráció az RTL+-ra",
        title: "Regisztráció az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Tartalmak és szolgáltatások",
        title: "Tartalmak és szolgáltatások",
        service: ["plus"],
        parent: "RTL+ Light"
      },
      {
        value: "Kupon kóddal kapcsolatos kérdések",
        title: "Kupon kóddal kapcsolatos kérdések",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Technikai segítségnyújtás",
        title: "Technikai segítségnyújtás",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Eszközök és beállítások",
        title: "Eszközök és beállítások",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Belépés az RTL+-ra",
        title: "Belépés az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Regisztráció az RTL+-ra",
        title: "Regisztráció az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Tartalmak és szolgáltatások",
        title: "Tartalmak és szolgáltatások",
        service: ["plus"],
        parent: "RTL+ Active (csak szolgáltatótól!)"
      },
      {
        value: "Kupon kóddal kapcsolatos kérdések",
        title: "Kupon kóddal kapcsolatos kérdések",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Technikai segítségnyújtás",
        title: "Technikai segítségnyújtás",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Eszközök és beállítások",
        title: "Eszközök és beállítások",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Belépés az RTL+-ra",
        title: "Belépés az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Regisztráció az RTL+-ra",
        title: "Regisztráció az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Tartalmak és szolgáltatások",
        title: "Tartalmak és szolgáltatások",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Számlázás és fizetés",
        title: "Számlázás és fizetés",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "UEFA",
        title: "UEFA",
        service: ["plus"],
        parent: "RTL+ Premium (One szolgáltatótól)"
      },
      {
        value: "Kupon kóddal kapcsolatos kérdések",
        title: "Kupon kóddal kapcsolatos kérdések",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Technikai segítségnyújtás",
        title: "Technikai segítségnyújtás",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Eszközök és beállítások",
        title: "Eszközök és beállítások",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Belépés az RTL+-ra",
        title: "Belépés az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Regisztráció az RTL+-ra",
        title: "Regisztráció az RTL+-ra",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Tartalmak és szolgáltatások",
        title: "Tartalmak és szolgáltatások",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "Számlázás és fizetés",
        title: "Számlázás és fizetés",
        service: ["plus"],
        parent: "RTL+ Premium"
      },
      {
        value: "UEFA",
        title: "UEFA",
        service: ["plus"],
        parent: "RTL+ Premium"
      }
    ]
  },
  moreCategory: {
    type: "select",
    id: "00N7Q00000GG2iz",
    name: "00N7Q00000GG2iz",
    title: "További alkategória",
    label: "Segítségre van szükségem, ezzel kapcsolatban",
    categoryName: "moreCategory",
    parentCategory: "subCategory",
    options: [
      {
        value: "Kuponkonstrukciókról érdeklődés",
        title: "Kuponkonstrukciókról érdeklődés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Kupon kóddal kapcsolatos kérdések"
      },{
        value: "Beváltás általános érdeklődés",
        title: "Beváltás általános érdeklődés",
        service: ["plus"],
        category: ["RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Kupon kóddal kapcsolatos kérdések"
      },
      {
        value: "Beváltás hibabejelentés",
        title: "Beváltás hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Kupon kóddal kapcsolatos kérdések"
      },
      {
        value: "Elfelejtett kuponkód",
        title: "Elfelejtett kuponkód",
        service: ["plus"],
        category: ["RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Kupon kóddal kapcsolatos kérdések"
      },
      {
        value: "Mobil eszköz hibabejelentés",
        title: "Mobil eszköz hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "LG TV hibabejelentés",
        title: "LG TV hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Samsung TV hibabejelentés",
        title: "Samsung TV hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Egyéb Android TV hibabejelentés",
        title: "Egyéb Android TV hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Böngészős hibabejelentés",
        title: "Böngészős hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Set-top boxos hibabejelentés",
        title: "Set-top boxos hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Tartalom lejátszás hibabejelentés",
        title: "Tartalom lejátszás hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Kapcsolódási hibabejelentés",
        title: "Kapcsolódási hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "RTL+ applikáció működése hibabejelentés",
        title: "RTL+ applikáció működése hibabejelentés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)",
        title: "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Technikai segítségnyújtás"
      },
      {
        value: "RTL+ alkalmazás információ",
        title: "RTL+ alkalmazás információ",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "Eszköz kompatibilitás",
        title: "Eszköz kompatibilitás",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "Eszközpárosítás nagyképernyőre",
        title: "Eszközpárosítás nagyképernyőre",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "Eszközök csatlakoztatása (HDMI/Chromecast)",
        title: "Eszközök csatlakoztatása (HDMI/Chromecast)",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "Eszközök profilhoz rendelése/leválasztása",
        title: "Eszközök profilhoz rendelése/leválasztása",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "RTL+ egyszerre több eszközön",
        title: "RTL+ egyszerre több eszközön",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Eszközök és beállítások"
      },
      {
        value: "Nem enged be a fiókomba",
        title: "Nem enged be a fiókomba",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Belépés az RTL+-ra"
      },
      {
        value: "Helytelen bejelentkezési adatok",
        title: "Helytelen bejelentkezési adatok",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Belépés az RTL+-ra"
      },
      {
        value: "Közösségi fiókkal való bejelentkezés",
        title: "Közösségi fiókkal való bejelentkezés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Belépés az RTL+-ra"
      },
      {
        value: "Általános információ",
        title: "Általános információ",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Belépés az RTL+-ra"
      },
      {
        value: "Elfelejtett jelszó",
        title: "Elfelejtett jelszó",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Belépés az RTL+-ra"
      },
      {
        value: "Nem enged regisztrálni",
        title: "Nem enged regisztrálni",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Regisztráció az RTL+-ra"
      },
      {
        value: "Közösségi fiókkal való regisztráció",
        title: "Közösségi fiókkal való regisztráció",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Regisztráció az RTL+-ra"
      },
      {
        value: "Megerősítő e-mail probléma",
        title: "Megerősítő e-mail probléma",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Regisztráció az RTL+-ra"
      },
      {
        value: "Sikertelen regisztrációs folyamat",
        title: "Sikertelen regisztrációs folyamat",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Regisztráció az RTL+-ra"
      },
      {
        value: "UEFA általános érdeklődés",
        title: "UEFA általános érdeklődés",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Reklámok az RTL+-on",
        title: "Reklámok az RTL+-on",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Nem elérhető feltöltött tartalom",
        title: "Nem elérhető feltöltött tartalom",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Nem elérhető élő közvetítés",
        title: "Nem elérhető élő közvetítés",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Személyes profil beállítások",
        title: "Személyes profil beállítások",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "RTL+ csomag lemondása információ",
        title: "RTL+ csomag lemondása információ",
        service: ["plus"],
        category: ["RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Profil teljes törlése információ",
        title: "Profil teljes törlése információ",
        service: ["plus"],
        category: ["RTL+ Light", "RTL+ Active (csak szolgáltatótól!)", "RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Tartalmak és szolgáltatások"
      },
      {
        value: "Általános információ",
        title: "Általános információ",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Sikeres fizetés, de nincs szolgáltatás - új előfizetés",
        title: "Sikeres fizetés, de nincs szolgáltatás - új előfizetés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Sikeres fizetés, de nincs szolgáltatás - meglévő előfizetés",
        title: "Sikeres fizetés, de nincs szolgáltatás - meglévő előfizetés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Sikertelen fizetés - új előfizetés",
        title: "Sikertelen fizetés - új előfizetés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Sikertelen fizetés - meglévő előfizetés",
        title: "Sikertelen fizetés - meglévő előfizetés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Kéretlen terhelés",
        title: "Kéretlen terhelés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Téves összegű terhelés",
        title: "Téves összegű terhelés",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Díjcsomag váltás információ",
        title: "Díjcsomag váltás információ",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Bankkártya műveletek",
        title: "Bankkártya műveletek",
        service: ["plus"],
        category: ["RTL+ Premium"],
        parent: "Számlázás és fizetés"
      },
      {
        value: "Megtekinthető mérkőzések",
        title: "Megtekinthető mérkőzések",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      },
      {
        value: "Külföldi megtekintés",
        title: "Külföldi megtekintés",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      },
      {
        value: "Nem megfelelő minőségű élő stream",
        title: "Nem megfelelő minőségű élő stream",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      },
      {
        value: "Nem elérhető élő stream",
        title: "Nem elérhető élő stream",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      },
      {
        value: "Nyilvános vetítési igény",
        title: "Nyilvános vetítési igény",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      },
      {
        value: "Általános információ",
        title: "Általános információ",
        service: ["plus"],
        category: ["RTL+ Premium (One szolgáltatótól)", "RTL+ Premium"],
        parent: "UEFA"
      }
    ]
  }
}

export const testInputs: FormInputs = [
  {
    type: "input",
    title: "Használt eszköz típusa",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"]
    ],
    attrs: {
      id: "00N7Q00000GG2hK",
      maxLength: "255",
      name: "00N7Q00000GG2hK",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Szoftver verziószáma",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"]
    ],
    attrs: {
      id: "00N7Q00000GG2hZ",
      maxLength: "255",
      name: "00N7Q00000GG2hZ",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Applikáció verziója",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"]
    ],
    attrs: {
      id: "00N7Q00000GG2hG",
      maxLength: "255",
      name: "00N7Q00000GG2hG",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Kapcsolódó eszközök száma",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"]
    ],
    attrs: {
      id: "00N7Q00000GG2hP",
      maxLength: "255",
      name: "00N7Q00000GG2hP",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Milyen eszközön nézi",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"]
    ],
    attrs: {
      id: "00N7Q00000GG2hS",
      maxLength: "255",
      name: "00N7Q00000GG2hS",
      type: "text"
    }
  },
  {
    type: "radio",
    title: "Használok VPN-t",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Megerősítő e-mail probléma"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Megerősítő e-mail probléma"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Megerősítő e-mail probléma"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "Kupon kóddal kapcsolatos kérdések", "Beváltás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Megerősítő e-mail probléma"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"]
    ],
    attrs: {
      id: "00NPw00000EyyKb",
      name: "00NPw00000EyyKb"
    },
    options: ["Igen", "Nem"]
  },
  {
    type: "radio",
    title: "AdBlock bővítményt használok",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"]
    ],
    attrs: {
      id: "00NPw00000EyyNp",
      name: "00NPw00000EyyNp"
    },
    options: ["Igen", "Nem"]
  },
  {
    type: "input",
    title: "Használni kívánt eszköz típus",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"]
    ],
    attrs: {
      id: "00N7Q00000GG2hM",
      maxLength: "255",
      name: "00N7Q00000GG2hM",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Csatorna megnevezése",
    mandatory: [],
    optional: [
      ["Televíziós adások", "Hírműsorok", "Híresemény bejelentés, észrevétel"],
      ["Televíziós adások", "Hírműsorok", "Szerepléssel kapcsolatos bejelentés"],
      ["Televíziós adások", "Hírműsorok", "Adáshibával kapcsolatos bejelentés"],
      ["Televíziós adások", "Időjárás jelentés", "Általános bejelentés, fotó beküldése"],
      ["Televíziós adások", "Időjárás jelentés", "Adáshibával kapcsolatos bejelentés"]
    ],
    attrs: {
      id: "00N7Q00000GG2hH",
      maxLength: "255",
      name: "00N7Q00000GG2hH",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Melyik országból nézi az RTL+-t?",
    mandatory: [],
    optional: [
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "RTL+ alkalmazás információ"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "Eszközök profilhoz rendelése/leválasztása"],
      ["RTL+ streaming", "RTL+ Light", "Eszközök és beállítások", "RTL+ egyszerre több eszközön"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Közösségi fiókkal való bejelentkezés"],
      ["RTL+ streaming", "RTL+ Light", "Belépés az RTL+-ra", "Általános információ"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Nem enged regisztrálni"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Közösségi fiókkal való regisztráció"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Megerősítő e-mail probléma"],
      ["RTL+ streaming", "RTL+ Light", "Regisztráció az RTL+-ra", "Sikertelen regisztrációs folyamat"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "UEFA általános érdeklődés"],
      ["RTL+ streaming", "RTL+ Light", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "RTL+ alkalmazás információ"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "Eszközök profilhoz rendelése/leválasztása"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Eszközök és beállítások", "RTL+ egyszerre több eszközön"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Közösségi fiókkal való bejelentkezés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Általános információ"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Belépés az RTL+-ra", "Elfelejtett jelszó"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Regisztráció az RTL+-ra", "Közösségi fiókkal való regisztráció"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "UEFA általános érdeklődés"],
      ["RTL+ streaming", "RTL+ Active (csak szolgáltatótól!)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "RTL+ alkalmazás információ"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "Eszközök profilhoz rendelése/leválasztása"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Eszközök és beállítások", "RTL+ egyszerre több eszközön"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Közösségi fiókkal való bejelentkezés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Belépés az RTL+-ra", "Elfelejtett jelszó"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Regisztráció az RTL+-ra", "Közösségi fiókkal való regisztráció"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "Számlázás és fizetés", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Megtekinthető mérkőzések"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Külföldi megtekintés"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Nyilvános vetítési igény"],
      ["RTL+ streaming", "RTL+ Premium (One szolgáltatótól)", "UEFA", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Mobil eszköz hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "LG TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Samsung TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Egyéb Android TV hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Böngészős hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Set-top boxos hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Tartalom lejátszás hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Kapcsolódási hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "RTL+ applikáció működése hibabejelentés"],
      ["RTL+ streaming", "RTL+ Premium", "Technikai segítségnyújtás", "Eszközök csatlakoztatás hibabejelentés (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "RTL+ alkalmazás információ"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszköz kompatibilitás"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszközpárosítás nagyképernyőre"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszközök csatlakoztatása (HDMI/Chromecast)"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "Eszközök profilhoz rendelése/leválasztása"],
      ["RTL+ streaming", "RTL+ Premium", "Eszközök és beállítások", "RTL+ egyszerre több eszközön"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Nem enged be a fiókomba"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Helytelen bejelentkezési adatok"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Közösségi fiókkal való bejelentkezés"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium", "Belépés az RTL+-ra", "Elfelejtett jelszó"],
      ["RTL+ streaming", "RTL+ Premium", "Regisztráció az RTL+-ra", "Közösségi fiókkal való regisztráció"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető feltöltött tartalom"],
      ["RTL+ streaming", "RTL+ Premium", "Tartalmak és szolgáltatások", "Nem elérhető élő közvetítés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Kéretlen terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Téves összegű terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Díjcsomag váltás információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Bankkártya műveletek"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Megtekinthető mérkőzések"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Külföldi megtekintés"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem megfelelő minőségű élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nem elérhető élő stream"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Nyilvános vetítési igény"],
      ["RTL+ streaming", "RTL+ Premium", "UEFA", "Általános információ"]
    ],
    attrs: {
      id: "00N7Q00000GG2hW",
      maxLength: "255",
      name: "00N7Q00000GG2hW",
      type: "text"
    }
  },
  {
    type: "input",
    title: "Számlavezető bank neve",
    mandatory: [
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Kéretlen terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Téves összegű terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Díjcsomag váltás információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Bankkártya műveletek"]
    ],
    optional: [],
    attrs: {
      id: "00NPw00000EyySf",
      maxLength: "255",
      name: "00NPw00000EyySf",
      type: "text"
    }
  },
  {
    type: "radio",
    title: "Bankkártya típusa",
    mandatory: [
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Általános információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikeres fizetés, de nincs szolgáltatás - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - új előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Sikertelen fizetés - meglévő előfizetés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Kéretlen terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Téves összegű terhelés"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Díjcsomag váltás információ"],
      ["RTL+ streaming", "RTL+ Premium", "Számlázás és fizetés", "Bankkártya műveletek"]
    ],
    optional: [],
    attrs: {
      id: "00NPw00000EyyUH",
      name: "00NPw00000EyyUH"
    },
    options: ["Mastercard", "Visa"]
  },
  {
    type: "text",
    title: "Műsorba való jelentkezés esetén keresd fel az alábbi linket: <a href=\"https://rtl.hu/casting\" target=\"_blank\">https://rtl.hu/casting</a>",
    optional: [
      ["Televíziós adások", "Casting", "Statisztának/szereplőnek/nézőnek való jelentkezés"],
      ["Televíziós adások", "Casting", "Castinggal kapcsolatos általános érdeklődés"],
      ["RTL.hu weboldal", "Casting", "Statisztának/szereplőnek/nézőnek való jelentkezés"],
      ["RTL.hu weboldal", "Casting", "Castinggal kapcsolatos általános érdeklődés"]
    ]
  },
  {
    type: "input",
    title: "Tárgy",
    mandatory: ["*"],
    attrs: {
      id: "subject",
      maxLength: "80",
      name: "subject",
      type: "text"
    }
  },
  {
    type: "textarea",
    title: "Kérdésed/problémád részletes leírása",
    mandatory: ['*'],
    attrs: {
      id: "description",
      maxLength: "32000",
      name: "description",
      type: "text"
    }
  }
];
